/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-05-27 15:31:31
 * @LastEditTime: 2022-05-31 16:38:46
 * @FilePath: \insurforce-backstage-platform-side\src\views\system\labelManage\utils.js
 */
const columns = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '标签名称'
  },
  dataIndex: 'fieldKey',
  key: 'fieldKey',
  align: 'center'
}, {
  slots: {
    title: '分类'
  },
  dataIndex: 'className',
  key: 'className',
  align: 'center'
}, {
  slots: {
    title: '分类'
  },
  dataIndex: 'typeName',
  key: 'typeName',
  align: 'center'
}, {
  slots: {
    title: '创建人'
  },
  dataIndex: 'userName',
  key: 'userName',
  align: 'center',
  ellipsis: true,
  customRender: (text, record) => h("a-tooltip", {
    "attrs": {
      "placement": "topLeft",
      "title": record.userName
    }
  }, [record.userName])
}, {
  slots: {
    title: '更新时间'
  },
  dataIndex: 'updateAt',
  key: 'updateAt',
  align: 'center'
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 180,
  scopedSlots: {
    customRender: 'operation'
  }
}];
const propertyColumns = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '属性名称'
  },
  dataIndex: 'fieldValue',
  key: 'fieldValue',
  align: 'center'
}, {
  slots: {
    title: '创建类型'
  },
  dataIndex: 'type',
  key: 'type',
  align: 'center'
}, {
  slots: {
    title: '创建人'
  },
  dataIndex: 'userName',
  key: 'userName',
  align: 'center',
  ellipsis: true,
  customRender: (text, record) => h("a-tooltip", {
    "attrs": {
      "placement": "topLeft",
      "title": record.userName
    }
  }, [record.userName])
}, {
  slots: {
    title: '更新时间'
  },
  dataIndex: 'updateAt',
  key: 'updateAt',
  align: 'center'
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 180,
  scopedSlots: {
    customRender: 'operation'
  }
}];
const pagination = {
  showSizeChanger: true,
  showQuickJumper: true,
  total: 0,
  pageSize: 10,
  // 每页条数
  page: 1,
  showTotal: total => {
    return `共 ${total} 条`;
  },
  onShowSizeChange: (current, size) => {
    pagination.pageSize = size;
  }
};
const ADD_RULES = {
  tagsName: [{
    required: true,
    message: '请输入标签名称',
    trigger: 'blur'
  }, {
    message: '1-30字符',
    max: 30,
    min: 1
  }],
  tagsClass: [{
    required: true,
    message: '请选择分类',
    trigger: 'change'
  }]
};
const PROPERTY_RULES = {
  fieldValue: [{
    required: true,
    message: '请输入属性名称',
    trigger: 'blur'
  }, {
    message: '1-30字符',
    max: 30,
    min: 1
  }]
};
const selectType = [{
  key: 'SYSTEM',
  value: '系统创建'
}, {
  key: 'INSURE',
  value: '投保生成'
}, {
  key: 'USER',
  value: '用户创建'
}];
export { columns, propertyColumns, pagination, ADD_RULES, PROPERTY_RULES, selectType };